module.exports = __webpack_public_path__ + "static/media/EndlessRiver.9d448b1c.jpg";